import { useEffect, useRef, useState } from "react";
import { Play, ArrowUpRight } from "lucide-react";

export const FLOW_CELLS_LIVE = "https://alpha.tradrquant.com/flow-cells/live";
const W = 1920;
const H = 800;

const Desktop = () => {
  const [play, setPlay] = useState(false);
  const [scale, setScale] = useState(0);
  const box = useRef(null);
  useEffect(() => {
    const ro = new ResizeObserver(([e]) => setScale(e.contentRect.width / W));
    ro.observe(box.current);
    return () => ro.disconnect();
  }, []);
  return (
    <div ref={box} data-testid="flow-cells-live" className="relative hidden aspect-[12/5] overflow-hidden border border-white/[0.08] bg-[#050608] sm:block">
      {play ? (
        <>
          <iframe src={FLOW_CELLS_LIVE} title="TradrQuant Flow Cells live whale rotation map" data-testid="flow-cells-iframe" data-lenis-prevent
            className="absolute left-0 top-0 origin-top-left border-0" style={{ width: W, height: H, transform: `scale(${scale})` }} allow="fullscreen" />
          <a href={FLOW_CELLS_LIVE} data-testid="flow-cells-fullscreen" className="absolute right-3 top-3 z-10 inline-flex items-center gap-1.5 border border-white/15 bg-black/75 px-2.5 py-1.5 font-mono text-[10px] uppercase tracking-[0.16em] text-[#ECEBE4] backdrop-blur-md transition-colors hover:border-white/40">
            Full screen <ArrowUpRight size={12} />
          </a>
        </>
      ) : (
        <button type="button" onClick={() => setPlay(true)} data-testid="flow-cells-play" aria-label="Play the live Flow Cells map" className="group absolute inset-0 block h-full w-full">
          <img src="/of/flowcells-live.webp" alt="Flow Cells live crypto whale rotation map with coin bubbles sized by volume" width="1600" height="667" loading="lazy" className="h-full w-full object-cover opacity-80 transition-opacity duration-500 group-hover:opacity-100" />
          <span className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
          <span className="absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 items-center gap-3 border border-white/20 bg-black/70 px-6 py-4 font-mono text-[12px] uppercase tracking-[0.16em] text-[#ECEBE4] backdrop-blur-md transition-[border-color,transform] duration-300 group-hover:scale-[1.03] group-hover:border-[#BACD1C]/60">
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-[#BACD1C] text-black"><Play size={14} fill="currentColor" /></span>
            Play live map
          </span>
          <span className="absolute bottom-3 left-3 flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-[#9DA3AE]"><span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[#BACD1C]" />Live data · loads on tap</span>
        </button>
      )}
    </div>
  );
};

const Mobile = () => (
  <div className="sm:hidden" data-testid="flow-cells-mobile">
    <a href={FLOW_CELLS_LIVE} className="block overflow-hidden border border-white/[0.08]">
      <img src="/of/flowcells.webp" alt="Flow Cells live crypto whale rotation map" width="1560" height="590" loading="lazy" className="block h-auto w-full" />
    </a>
    <a href={FLOW_CELLS_LIVE} data-testid="flow-cells-mobile-open" className="mt-3 flex items-center justify-center gap-2 border border-white/20 py-3.5 font-mono text-[12px] uppercase tracking-[0.14em] text-[#ECEBE4]">
      Open live map <ArrowUpRight size={14} />
    </a>
  </div>
);

export const LiveFlowCells = () => (
  <>
    <Desktop />
    <Mobile />
  </>
);
